import { c as _c } from "react/compiler-runtime";
export const Sparkle = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M9.96666 20.4999C10.0466 20.4973 10.11 20.4286 10.1112 20.3446C10.1291 19.0934 10.3701 17.8564 10.8217 16.6994C11.2915 15.4959 11.9801 14.4024 12.8482 13.4814C13.7164 12.5604 14.7468 11.8299 15.881 11.3316C17.0151 10.8333 18.2307 10.5769 19.4582 10.5772C20.1806 10.5772 20.1806 10.4181 19.4582 10.4181C18.2307 10.4184 17.0151 10.162 15.881 9.6637C14.7468 9.16538 13.7164 8.43485 12.8482 7.51385C11.9801 6.59284 11.2915 5.49939 10.8217 4.29594C10.3706 3.14032 10.1298 1.90502 10.1112 0.655248C10.11 0.569515 10.0438 0.5 9.9622 0.5C9.88029 0.5 9.81415 0.569602 9.81303 0.655409C9.79573 1.90594 9.55559 3.14222 9.10503 4.29888C8.63564 5.50343 7.94732 6.59803 7.07913 7.52004C6.21095 8.44207 5.17994 9.17344 4.0452 9.67237C2.91045 10.1713 1.69416 10.428 0.465875 10.4277C-0.155292 10.4277 -0.155292 10.5867 0.465875 10.5867C1.6934 10.5865 2.90896 10.8428 4.04311 11.3412C5.17726 11.8395 6.20788 12.57 7.07592 13.491C7.94397 14.412 8.63257 15.5055 9.10238 16.7089C9.55294 17.8629 9.79378 19.0966 9.81275 20.3446C9.81415 20.4323 9.88308 20.5026 9.96666 20.4999Z" fill="#FFF48E" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};